import React from 'react';
import { connect } from 'react-redux';

import { ModalForm, TextField, Intl } from 'components';
import SettingsActions from 'store/reducers/Settings';
import { required } from 'config/InputErrors';
import { Button } from 'reactstrap';

const SaveFavouriteModal = ( {
  open, values, onClose, onSubmit,
} ) => (
  <ModalForm
    showErrorsInHeader
    size="md"
    open={open}
    onClose={onClose}
    onSubmit={onSubmit}
    initialValues={values}
    body={() => (
      <TextField
        labelClass="text-center w-100 text-body text-md"
        label="writeFileNumber"
        field="originalName"
        validate={required}
      />
    )}
    footer={(
      <Button
        color="app-default"
        size="app-sm"
        className="font-weight-700"
      >
        <Intl id="save" />
      </Button>
    )}
  />
);

const mapDispatchToProps = ( {
  toggleLoading: SettingsActions.toggleLoading,
} );

export default connect( null, mapDispatchToProps )( SaveFavouriteModal );
